import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { map } from 'rxjs/operators';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FamiliaequipoService {

  private endpoint: string | null;

  constructor(
    private httpClient: HttpClient
  ) { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/catalogos/Familia';
  }

  getFamiliaEquipo(){
    return this.httpClient.get(this.endpoint + '/GetFamilia');
  }

  insertFamilia(model: any){
    return this.httpClient.post(this.endpoint + '/InsertFamilia', model);
  }

  updateFamilia(model: any){
    return this.httpClient.post(this.endpoint + '/UpdateFamilia', model);
  }

  obtenerFamiliaCatalog() {
    return this.getFamiliaEquipo().pipe(
      map((data: any) => {
        if (data?.Familia) {
          return data.Familia
            .filter((i: any) => i['valor'] !== '')
            .map((i: any) => ({ label: i.valor, value: i.valor}));
        }
        return [];
      })
    );
  }
}
